<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>
<style>
    @import "./assets/font/font.css";

    body {
        margin: 0;
    }

    ::-webkit-scrollbar {
        width: 6px !important;
    }

    ::-webkit-scrollbar {
        width: 6px !important;
        height: 6px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 8px !important;
        background-color: #858585 !important;
    }

    /*.BMap_cpyCtrl {*/
    /*    display: none !important;*/
    /*}*/

    /*.anchorBL {*/
    /*    display: none*/
    /*}*/

    .el-message-box {
        background-color: #23262E !important;
        border: none !important;
    }

    .el-message-box__title {
        color: #FFFFFF !important;
        border-bottom: 1px solid #727A8E !important;
        padding-bottom: 15px !important;
    }

    .el-message-box__header {
        padding-bottom: 0 !important;
    }

    .el-message-box__message {
        color: #BBBBBB !important;
    }

    .el-message-box__btns .el-button--default {
        color: #BBBBBB !important;
        background: #40444E !important;
        border: none !important;
    }

    .el-message-box__btns .el-button--default:hover {
        color: #BBBBBB !important;
        background: #40444E !important;
    }

    .el-message-box__btns .el-button--primary {
        color: #ffffff !important;
        background: #20D38F !important;
    }

    .el-message-box__btns .el-button--primary:hover {
        color: #ffffff !important;
        background: #20D38F !important;
    }

    .el-picker-panel {
        color: #c0c4cc !important;
        background: #23262E !important;
        box-shadow: 0px 0px 15px #000000 !important;
        border: none !important;
        /*font-family: CFONT;*/
    }

    .popper__arrow {
        display: none !important;
    }

    .el-date-table {
        font-family: CFONT;
    }

    .el-date-table td.start-date span {
        background-color: #20D38F !important;
    }

    .el-date-table td.end-date span {
        background-color: #20D38F !important;
    }

    .el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div {
        background-color: #00482D !important;
    }

    .el-date-table td.in-range div span {
        color: #ffffff !important;
    }

    .el-date-table td.today span {
        font-weight: 400 !important;
    }

    .el-date-range-picker__content .el-date-range-picker__header div {
        color: #BBBBBB !important;
        font-size: 18px !important;
    }

    .el-picker-panel__icon-btn {
        color: #BBBBBB !important;
    }

    .el-picker-panel__icon-btn:hover {
        color: #20D38F !important;
    }

    .el-date-table td span {
        font-size: 20px !important;
    }

    .el-date-table th {
        border-bottom: none !important;
        background-color: #393C43 !important;
        padding: 0 !important;
        color: #C1C1C1 !important;
        font-weight: 400 !important;
        font-size: 16px !important;
    }

    .el-date-range-picker table {
        margin-top: 10px !important;
    }

    .el-date-table td.today span, .el-date-table td.available:hover {
        color: #20D38F !important;
    }

    .el-date-table td.next-month, .el-date-table td.prev-month {
        color: #888888 !important;
    }

    .el-popper .popper__arrow::after {
        display: none !important;
    }

    .el-popper[x-placement^=bottom] .popper__arrow {
        display: none !important;
    }

    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        background-color: #40444E !important;
        color: #BBBBBB !important;
        /*font-family: CFONT !important;*/
        font-weight: 400 !important;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #20D38F !important;
        color: #ffffff !important;
    }

    .el-pagination.is-background .btn-next.disabled, .el-pagination.is-background .btn-next:disabled, .el-pagination.is-background .btn-prev.disabled, .el-pagination.is-background .btn-prev:disabled, .el-pagination.is-background .el-pager li.disabled {
        color: #BBBBBB !important;
    }

    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #ffffff !important;
    }

    .el-pagination__sizes .el-input .el-input__inner, .el-pagination__editor.el-input .el-input__inner {
        background-color: #40444E !important;
        color: #BBBBBB !important;
        border: none !important;
    }

    .el-pagination__jump {
        margin-left: 0 !important;
        color: #BBBBBB !important;
    }

    .el-table .el-table__cell {
        padding: 5px 0 !important;
    }

    .el-table__header thead tr th {
        background-color: #000000 !important;
        color: #BBBBBB !important;
    }

    .el-table tr {
        background-color: #2c2d31 !important;
        color: #BBBBBB !important;
    }

    .el-table__body tr.hover-row.current-row > td.el-table__cell, .el-table__body tr.hover-row.el-table__row--striped.current-row > td.el-table__cell, .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell, .el-table__body tr.hover-row > td.el-table__cell {
        background-color: #40444E !important;
        color: #ffffff !important;
        cursor: pointer;
    }

    .hover-row td.el-table__cell div.cell  div.delete-box {
        opacity: 1;
    }


    .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: 2px solid #23262e !important;
    }

    .el-table--border::after, .el-table--group::after, .el-table::before, .el-table__fixed-right::before, .el-table__fixed::before {
        background-color: #23262e !important;
    }

    .el-table, .el-table__expanded-cell {
        background-color: #23262e !important;
    }

    .el-tooltip__popper {
        background: #727A8E !important;
    }

    .el-tooltip__popper[x-placement^=top] .popper__arrow:after {
        border-top-color: #727A8E !important;
    }

    .copyright {
        color: #999999;
        text-align: center;
        margin: 20px 0;
        width: 100%;
        font-family: Source Han Sans CN;
    }

    .tianao {
        font-size: 14px;
    }

    i {
        font-size: 24px;
    }

    /deep/ .el-cascader__dropdown {
        background: rgba(0,111,255,0.1) !important;
    }

    .el-range-input {
        background-color: transparent !important;
    }

    .el-range-separator {
        color: #ffffff !important;
    }

    .el-table__body tr:hover>td.el-table__cell {
        background-color: #40444E !important;
    }

    .el-table--border, .el-table--border .el-table__cell {
        border: none !important;
    }

    .el-table__header thead tr th {
        background-color: #023376 !important;
        color: #ffffff !important;
    }

    .el-table tr {
        background-color: #031D41 !important;
        color: #ffffff !important;
        font-size: 14px;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background-color: #1E2433 !important;
    }

    .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: 8px solid #040C1C !important;
    }

    .el-table--border::after, .el-table--group::after, .el-table::before, .el-table__fixed-right::before, .el-table__fixed::before {
        background-color: transparent !important;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #0088FF !important;
    }

    .el-dialog {
        background: #0F161E !important;
        box-shadow: 3px 3px 10px 1px #000000 !important;
        border-radius: 20px 20px 20px 20px;
    }

    .el-dialog__title {
        font-size: 18px;
        color: #FFFFFF !important;
    }

    .el-form-item__label {
        font-size: 14px;
        color: #FFFFFF !important;
    }

    .el-picker-panel {
        font-size: 14px;
    }

    .el-textarea__inner {
        background-color: rgba(0, 111, 255, 0.1) !important;
        color: #ffffff !important;
        border: 0.005208rem solid rgba(0, 136, 255, 0.6) !important;
    }


    .btn-admin {
        width: 280px;
        height: 50px;
        background-image: url("~@/assets/home/04btn.png");
        background-size: cover;
        box-sizing: border-box;
        overflow: hidden;
        position: absolute;
        right: 73px;
        top: 61px;
    }

    .btn-icon {
        width: 34px;
        position: absolute;
        right: 295px;
        top: 69px;
    }

    .user-name {
        width: 74px;
        height: 32px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: absolute;
        right: 214px;
        top: 70px;
        font-size: 24px;
        color: #ffffff;
        line-height: 32px;
        cursor: pointer;
    }

    .time-box {
        width: 91px;
        height: 41px;
        font-size: 16px;
        color: #ffffff;
        position: absolute;
        right: 88px;
        top: 65px;
        line-height: 20px;
    }

    .btn-data {
        left: 1385px;
    }


    .top-box {
        width: 100%;
        height: 130px;
        position: relative;
    }

    .btn-active {
        width: 153px;
        height: 39px;
        background-image: url("~@/assets/home/02btn.png");
        background-size: cover;
        box-sizing: border-box;
        overflow: hidden;
        color: #fff;
        font-size: 24px;
        font-family: PM;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 72px;
        cursor: pointer;
    }

    .btn {
        width: 153px;
        height: 39px;
        background-image: url("~@/assets/home/03btn.png");
        background-size: cover;
        box-sizing: border-box;
        overflow: hidden;
        color: #88ADCE;
        font-size: 24px;
        font-family: PM;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 72px;
        cursor: pointer;
    }

    .btn-device {
        left: 228px;
    }

    .btn-patient {
        left: 391px;
    }

    .btn-home {
        left: 63px;
    }

    .el-table__body-wrapper {
        overflow-y: auto !important;
        height: 560px !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue